import type Store from "@ember-data/store";
import Route from "@ember/routing/route";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import type CompoundSurveyCompletedJournalEvent from "parog-web/models/compound-survey-completed-journal-event";

import type Patient from "parog-web/models/patient";
import type NavigationService from "parog-web/services/navigation";

export interface CompoundSurveyCompletedAndPatient {
  patient: Patient;
  surveyCompletedJe: CompoundSurveyCompletedJournalEvent;
}

interface Params extends Record<string, string> {
  survey_id: string;
}

export default class CompoundSurveysNewRoute extends Route {
  @service declare navigation: NavigationService;
  @service declare router: RouterService;
  @service declare store: Store;

  override afterModel(model: CompoundSurveyCompletedAndPatient | null): void {
    if (!model) {
      this.router.transitionTo(
        this.navigation.currentPatientRouteName + ".compound-surveys"
      );
    }
  }

  override model({
    survey_id
  }: Params): CompoundSurveyCompletedAndPatient | null {
    const patient = this.modelFor(
      this.navigation.currentPatientRouteName
    ) as Patient;

    const survey = patient.healthCentre.surveys.find(
      survey => survey.id === survey_id
    );

    if (!survey) return null;

    const surveyCompletedJe = this.store.createRecord(
      "compound-survey-completed-journal-event",
      {
        occurredAt: new Date(),
        surveyIdentifier: survey.id,
        surveyRaw: survey.serialize()
      }
    );

    return { patient, surveyCompletedJe };
  }
}
